// Grid lines drawn only along the value axis (perpendicular to the
// category axis), with grid axis ids that actually exist in the current
// orientation — the previous code hard-coded `yAxisId="left"`, which
// does not exist when the chart is horizontal.

import { CartesianGrid } from 'recharts';

import { CHART_SHADE, mantineColorVar } from '#core/lib/formatters/colors.ts';

import type { ChartOrientation } from './chartOrientation.ts';

export function OrientedCartesianGrid({ o }: { o: ChartOrientation }) {
  return (
    <CartesianGrid stroke={mantineColorVar('dark', CHART_SHADE.gridLine)} strokeOpacity={0.5} {...o.gridProps()} />
  );
}
